module.exports = __webpack_public_path__ + "img/wpp.f589dedd.png";